<template>
<div>
    <div class="row">
        <div :class="['col_12', {'loading_overlay': loading}]">
            <div class="card no_border">
                <div class="card-header">
                    <div class="card-title">{{ title }}</div>
                </div>
                <div class="card-body pl_0 pr_0">
                    <div class="row">
                        <div class="col_4">
                            <div :class="['form-group', {'has_error': errorFor('grade_id')}]">
                                <label>{{ $t('common.grade') }}</label>
                                <select v-model="form.grade_id" class="form_global">
                                    <option value="">{{ $t('common.select_grade') }}</option>
                                    <option :value="item.id" v-for="item in grades" :key="'grade '+item.id">{{ item.name }}</option>
                                </select>
                                <v-errors :errors="errorFor('grade_id')" />
                            </div>
                        </div>
                        <div class="col_4">
                            <div :class="['form-group', {'has_error': errorFor('semester_id')}]">
                                <label>{{ $t('sidebar.semesters.semesters') }}</label>
                                <select v-model="form.semester_id" class="form_global">
                                    <option value="">{{ $t('common.select_semester') }}</option>
                                    <option :value="item.id" v-for="item in semesters" :key="'semester_id '+item.id">{{ item.name }}</option>
                                </select>
                                <v-errors :errors="errorFor('semester_id')" />
                            </div>
                        </div>
                        <div class="col_4">
                            <div :class="['form-group', {'has_error': errorFor('name')}]">
                                <label>{{ $t('common.name') }}</label>
                                <input type="text" v-model="form.name" class="form_global">
                                <v-errors :errors="errorFor('name')" />
                            </div>
                        </div>
                    </div>
                    <div class="d_flex_end form_action_btn">
                        <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                        <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            title: this.$t('sidebar.chapter.add_chapter'),
            cancelRouteName: 'settings_chapter',
            semesters: [],
            grades: [],
            form: {
                name: '',
                grade_id: '',
                semester_id: '',
            }
        }
    },
    created() {
        this.axios.get('/grades').then((response) => this.grades = response.data.data);
        this.axios.get('/semesters').then((response) => this.semesters = response.data.data);

        if (this.$route.name === 'settings_chapter_edit') {
            this.axios.get('/chapters/' + this.$route.params.id)
                .then((response) => {
                    this.form = response.data.data;
                })
            this.title = this.$t('sidebar.chapter.edit_chapter');
        }
    },
    methods: {
        submit() {
            this.allErrors = null;
            this.loading = true;

            if (this.$route.name === 'settings_chapter_edit') {
                this.axios.patch('/chapters/' + this.$route.params.id, this.form)
                    .then(() => {
                        this.$router.push({
                            name: 'settings_chapter'
                        });
                        this.showSuccessMsg(this.$t('common.updateSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.axios.post('/chapters', this.form)
                    .then(() => {
                        this.$router.push({
                            name: 'settings_chapter'
                        });
                        this.showSuccessMsg(this.$t('common.addSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
}
</script>
